module.exports = F2;


//////////////////
// WEBPACK FOOTER
// external "F2"
// module id = 4vQ8
// module chunks = 127